/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
//
export const GRANULARITY = {
  DAILY: 'Date',
  WEEKLY: 'Week of Year',
  MONTHLY: 'Month',
  YEARLY: 'Year',
};
//
export const STAY_DATE_RANGE = 'Stay Date Range';
export const STAY_DATE_COMPARISON = 'Comparison';
export const BOOKING_DATE_RANGE = 'Booking Date Range';
export const BOOKING_DATE_COMPARISON = 'Comparison';
export const REPORTING_CURRENCY = 'Reporting Currency';
export const COMPARISON = 'Comparison';
export const PACE_HORIZON = 'Pace Horizon';
//
export const PACE_TIME_TABULAR_TITLE = 'Pace Time Daily Tabular View';
export const PACE_TIME_CUMULATIVE_TITLE = 'Pace Time Cumulative Tabular View';
export const PACE_TIME_TABULAR_LAG_ALIGNED_TITLE = 'Pace Time Lag-aligned Tabular View';
export const PACE_TIME_CUMULATIVE_LAG_ALIGNED__TITLE =
  'Pace Time Cumulative Lag-aligned Tabular View';
export const PACE_HOTEL_TABULAR_TITLE = 'Pace Hotel Daily Tabular View';
export const PACE_HOTEL_CUMULATIVE_TITLE = 'Pace Hotel Cumulative Tabular View';
export const PACE_SEGMENT_TABULAR_TITLE = 'Pace Segment Daily Tabular View';
export const PACE_SEGMENT_CUMULATIVE_TITLE = 'Pace Segment Cumulative Tabular View';
export const PACE_SEGMENT_LAG_ALIGNED_TITLE = 'Pace Segment Lag Aligned Tabular View';
export const PACE_SEGMENT_CUMULATIVE_LAG_ALIGNED_TITLE =
  'Pace Segment Cumulative Lag Aligned Tabular View';
export const PACE_TIME_SEGMENT_LAG_ALIGNED_TITLE =
  'Combined Pace Time Segment Lag Aligned Tabular View';
export const PACE_TIME_SEGMENT_TITLE = 'Combined Pace Time Segment Tabular View';
export const PACE_TIME_SEGMENT_CUMULATIVE_TITLE =
  'Combined Cumulative Pace Time Segment Tabular View';
export const PACE_TIME_SEGMENT_CUMULATIVE_LAG_ALIGNED_TITLE =
  'Combined Cumulative Pace Time Segment Lag Aligned Tabular View';
export const PACE_HOTEL_SEGMENT_TABULAR_TITLE = 'Combined Pace Hotel Segment Tabular View';
export const PACE_HOTEL_SEGMENT_CUMULATIVE_TITLE =
  'Combined Cumulative Pace Hotel Segment Tabular View';
export const PACE_HOTEL_SEGMENT_LAG_ALIGNED_TITLE =
  'Combined Pace Hotel Segment Lag Aligned Tabular View';
export const PACE_HOTEL_SEGMENT_CUMULATIVE_LAG_ALIGNED_TITLE =
  'Combined Cumulative Pace Hotel Segment Lag Aligned Tabular View';
//
export const PACE_TIME_FORECAST_CUMULATIVE_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_aligned_cumulative_forecast',
  },
];
export const PACE_TIME_FORECAST_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_cumulative_forecast',
  },
];
export const PACE_TIME_LAG_ALIGNED_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_aligned_cumulative',
  },
];
export const PACE_TIME_FORECAST_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_lag_aligned_forecast',
  },
];
export const PACE_TIME_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_cumulative',
  },
];
export const PACE_TIME_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_lag_aligned',
  },
];
export const PACE_TIME_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_daily_forecast',
  },
];
export const PACE_TIME_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_daily',
  },
];
export const PACE_HOTEL_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_daily',
  },
];
export const PACE_HOTEL_DAILY_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_daily_forecast',
  },
];
export const PACE_HOTEL_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_cumulative',
  },
];
export const PACE_HOTEL_CUMULATIVE_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_cumulative_forecast',
  },
];
export const PACE_HOTEL_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_lag_aligned_daily',
  },
];
export const PACE_HOTEL_CUMULATIVE_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_lag_aligned_cumulative',
  },
];
export const PACE_HOTEL_LAG_ALIGNED_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_lag_aligned_daily_forecast',
  },
];
export const PACE_HOTEL_CUMULATIVE_LAG_ALIGNED_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_lag_aligned_cumulative_forecast',
  },
];
export const PACE_SEGMENT_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_segment_daily',
  },
];
export const PACE_SEGMENT_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_segment_cumulative',
  },
];
export const PACE_SEGMENT_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_segment_lag_aligned_daily',
  },
];
export const PACE_SEGMENT_CUMULATIVE_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_segment_lag_aligned_cumulative',
  },
];
export const PACE_TIME_SEGMENT_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_segment_lag_aligned_daily',
  },
];
export const PACE_TIME_SEGMENT_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_segment_daily',
  },
];
export const PACE_TIME_SEGMENT_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_segment_cumulative',
  },
];
export const PACE_TIME_SEGMENT_LAG_ALIGNED_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_time_segment_lag_aligned_cumulative',
  },
];
export const PACE_HOTEL_SEGMENT_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_segment_daily',
  },
];
export const PACE_HOTEL_SEGMENT_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_segment_cumulative',
  },
];
export const PACE_HOTEL_SEGMENT_LAG_ALIGNED_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_segment_lag_aligned_daily',
  },
];
export const PACE_HOTEL_SEGMENT_LAG_ALIGNED_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'pace_hotel_segment_lag_aligned_cumulative',
  },
];
//
export const PACE_TIME_SEGMENT_CUMULATIVE_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_SEGMENT_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_SEGMENT_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Metric',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_SEGMENT_CUMULATIVE_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Metric',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_SEGMENT_CUMULATIVE_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_SEGMENT_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_SEGMENT_CUMULATIVE_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Metric',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_SEGMENT_DAILY_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Metric',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
//
export const PACE_TIME_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Date',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_FORECAST_SCHEMA = [
  {
    id: 'selected_booking_date',
    label: 'Date',
    children: [
      {
        id: 'selected_booking_date',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_CUMULATIVE_SCHEMA = [
  {
    id: 'BookingDate',
    label: 'Date',
    children: [
      {
        id: 'BookingDate',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancellations',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancellations',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_LAG_ALIGNED_FORECAST_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancellation_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancellation_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_LAG_ALIGNED_CUMULATIVE_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_CUMULATIVE_FORECAST_SCHEMA = [
  {
    id: 'BookingDate',
    label: 'Date',
    children: [
      {
        id: 'BookingDate',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancellations',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancellations',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_TIME_LAG_ALIGNED_CUMULATIVE_FORECAST_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue',
        label: 'Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'Selection',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'Comparison',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
//
export const PACE_HOTEL_DAILY_SCHEMA = [
  {
    id: 'BookingDate',
    label: 'Date',
    children: [
      {
        id: 'BookingDate',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'room_nights_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'total_revenue_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'ADR_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'ADR_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'ADR_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'cancellation_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancellation_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancellation_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_CUMULATIVE_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancellations',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancellations',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_LAG_ALIGNED_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
export const PACE_HOTEL_DAILY_FORECAST_SCHEMA = [
  {
    id: 'BookingDate',
    label: 'Date',
    children: [
      {
        id: 'BookingDate',
        label: 'Date',
        type: 'string',
        align: 'left',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'room_nights_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms_selected',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_rooms_comparison',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'total_revenue_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue_selected',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'forecast_revenue_comparison',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'ADR_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'ADR_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'ADR_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'cancellation_selected',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancellation_comparison',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancellation_percentage_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
//
export const PACE_HOTEL_LAG_ALIGNED_FORECAST_SCHEMA = [
  {
    id: 'Lag',
    label: 'Metric',
    children: [
      {
        id: 'Lag',
        label: 'Lags',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'selected_forecast_rooms',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_forecast_rooms',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'selected_forecast_revenue',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_forecast_revenue',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancelled_count',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancelled_count',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
//

//
export const PACE_HOTEL_LAG_ALIGNED_CUMULATIVE_FORECAST_SCHEMA = [
  {
    id: 'Lag',
    label: 'Lag',
    children: [
      {
        id: 'Lag',
        label: 'Lag',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      {
        id: 'selected_rooms',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_rooms',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'rooms_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'selected_forecast_rooms',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      {
        id: 'selected_revenue',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_revenue',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'revenue_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'selected_forecast_revenue',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      {
        id: 'selected_adr',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_adr',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'adr_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      {
        id: 'selected_cancellations',
        label: 'A Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'comparison_cancellations',
        label: 'B Actls',
        type: 'number',
        align: 'right',
      },
      {
        id: 'cancelled_pct_change',
        label: '%Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];
//
export const PACE_HOTEL_CUMULATIVE_FORECAST_SCHEMA = [
  {
    id: 'BookingDate',
    label: 'Date',
    children: [{ id: 'BookingDate', label: 'Date', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '%Chg', type: 'string', align: 'right' },
      {
        id: 'room_nights_forecast_selected',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_forecast_comparison',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '%Chg', type: 'string', align: 'right' },
      {
        id: 'total_revenue_forecast_selected',
        label: 'A Fcsts',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_forecast_comparison',
        label: 'B Fcsts',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '%Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation_count',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '%Chg', type: 'string', align: 'right' },
    ],
  },
];
//
export const COMPARE_WINDOW_MAP = {
  'vs Previous Week (OTB)': 'PreviousWeek',
  'vs Previous Month (OTB)': 'PreviousMonth',
  'vs Previous Year (OTB)': 'PreviousYear',
};
//
export const PACE_HORIZON_FILTER = 'paceHorizon';
export const MAX_BOOKING_FILTER = 'maxBookingDate';

export const CERULEAN_GRANULARITY_THRESHOLD={
  YEARLY: 1460,
  MONTHLY: 365,
  WEEKLY: 60,
}
export const CERULEAN_TABLE_SECONDARY_TEXT_COLOR = '#d43754';